<div class="no-data-placeholder-container">
    <mat-icon>{{ icon }}</mat-icon>
    <div class="description">
        {{ text }}
    </div>
</div>